import React from 'react'
import styled from '@emotion/styled'
import Select from 'react-select'

import { STATUS } from 'Constants'

const SelectStatus = styled(Select)`
  width: 100%;
`

export const allOptionStatus = { value: null, label: 'All' }
export const statusOptions = Object.keys(STATUS).map(statusItem => {
  let statusLabel = statusItem.charAt(0) + statusItem.toLowerCase().slice(1)
  if (STATUS[statusItem] === 4) statusLabel = 'Given To Dr'
  if (STATUS[statusItem] === 5) statusLabel = 'Received Back'
  if (STATUS[statusItem] === 6) statusLabel = 'Left voicemail'
  if (STATUS[statusItem] === 7) statusLabel = 'Scheduled with urgent care'
  if (STATUS[statusItem] === 8) statusLabel = 'Appt in 2 weeks'
  if (STATUS[statusItem] === 9) statusLabel = 'Appt in 4 weeks'
  if (STATUS[statusItem] === 10) statusLabel = 'Check Tasks'
  if (STATUS[statusItem] === 11) statusLabel = 'Scan to record/chart'
  if (STATUS[statusItem] === 12) statusLabel = 'Follow-up with patient'
  if (STATUS[statusItem] === 13) statusLabel = 'Reviewed'
  if (STATUS[statusItem] === 14) statusLabel = 'Given to Care Coordinator'

  return {
    value: STATUS[statusItem],
    label: statusLabel
  }
})

export default React.memo(({ includeAll, ...props }) => {
  const options = [...statusOptions]
  if (includeAll) {
    options.unshift(allOptionStatus)
  }

  return <SelectStatus options={options} {...props} />
})
